import { render, staticRenderFns } from "./RequisiteSelect.vue?vue&type=template&id=8f942080&scoped=true&"
import script from "./RequisiteSelect.vue?vue&type=script&lang=js&"
export * from "./RequisiteSelect.vue?vue&type=script&lang=js&"
import style0 from "./RequisiteSelect.vue?vue&type=style&index=0&id=8f942080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f942080",
  null
  
)

export default component.exports